import React from 'react';
import { useTranslation } from 'react-i18next';
import { WeezHeader } from '@weezevent/nacre';
import Steps from './components/Steps';
import css from './styles.module.css';

export default function InvitationsLight({ organization, event }) {
    const { t } = useTranslation();

    return (
        <div id={css['invitations-light']}>
            <WeezHeader title={t('attendees.invitations.title')}>{t('attendees.invitations.subtitle')}</WeezHeader>
            <Steps organization={organization} event={event} />
        </div>
    );
}
